import HelpLayout from "@/components/layout/HelpLayout";
import { LoadingScreen } from "@/components/layout/Loading";
import AbrirChamadoCard from "@/components/pages/client/cards/abrir-chamado";
import ChamadosAbertosCard from "@/components/pages/client/cards/chamados-abertos";
import Mkt1Card from "@/components/pages/client/cards/mrkt-1";
import FaqStepsNav from "@/components/ui/faq-steps-nav";
import HelpNavigationTabs from "@/components/ui/help-navigation-tabs";
import { useFaqData } from "@/hooks/useFaqData";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PerguntasFrequentesPage() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState("step1");
  const [openQuestion, setOpenQuestion] = useState<string | null>(null);
  const { faqSteps, isLoading, error } = useFaqData();

  const toggleQuestion = (question: string) => {
    setOpenQuestion(openQuestion === question ? null : question);
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (error) {
    return (
      <HelpLayout title="Perguntas frequentes">
        <div className="text-center py-8 text-red-500">
          <p>Erro ao carregar perguntas frequentes: {error}</p>
        </div>
      </HelpLayout>
    );
  }

  const currentStepData =
    faqSteps.find((step) => step.id === currentStep) || faqSteps[0];

  return (
    <HelpLayout title="Perguntas frequentes">
      <div className="flex flex-col gap-3 lg:flex-row lg:gap-8">
        <div className="w-full space-y-6 lg:basis-2/3">
          <div className="flex flex-col gap-6 rounded-2xl border border-gray-200 bg-white p-3 sm:p-6 shadow-sm">
            <HelpNavigationTabs className="md:mb-6" />
            <h2 className="text-xl font-semibold text-n-green mx-3">
              {currentStepData?.title || "Perguntas Frequentes"}
            </h2>

            <FaqStepsNav
              defaultValue={currentStep}
              onStepChange={(step) => {
                setCurrentStep(step);
                setOpenQuestion(null);
              }}
            />

            <div className="md:mt-8 space-y-6 px-2">
              {currentStepData?.questions?.map((item) => (
                <div
                  key={`${currentStep}-${item.question}`}
                  className="border-b border-gray-200 pb-6 last:border-b-0 last:pb-0"
                >
                  <button
                    onClick={() => toggleQuestion(item.question)}
                    className="flex w-full items-start justify-between text-left"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {item.question}
                    </h3>
                    <svg
                      className={`h-5 w-5 transform transition-transform ${
                        openQuestion === item.question ? "rotate-180" : ""
                      }`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {openQuestion === item.question && (
                    <p className="mt-6 text-n-text-neutral">{item.answer}</p>
                  )}
                </div>
              )) || (
                <div className="text-center py-8 text-n-text-neutral">
                  <p>Carregando perguntas frequentes...</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex flex-col md:gap-5 gap-2 w-full  lg:mt-0 lg:basis-1/3">
          <AbrirChamadoCard onClick={() => navigate("/cliente/ajuda/abrir-chamado")} />
          <ChamadosAbertosCard onClick={() => navigate("/cliente/ajuda/chamados-abertos")} />
          <Mkt1Card />
        </div>
      </div>
    </HelpLayout>
  );
}
